
import { useState } from 'react';
import { Button } from '../ui';
import { askGemini } from '../../lib/gemini';
import { Sparkles, Plus, Copy, RefreshCw } from 'lucide-react';

export const AITeamGenerator = ({ onAddTeam }) => {
    const [theme, setTheme] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);

    const generateNames = async () => {
        if (!theme) return;
        setLoading(true);
        setSuggestions([]);

        try {
            const prompt = `Bedenk 5 unieke, grappige of stoere teamnamen voor een toernooi.
            Thema: ${theme}.
            Geef ALLEEN de namen terug, elk op een nieuwe regel. Geen nummers of bullets.`;

            const result = await askGemini(prompt);
            // Split lines and filter empty strings
            const names = result.split('\n').filter(n => n.trim().length > 0).map(n => n.replace(/^[-*•\d\.]+\s*/, '')); // Remove bullets if AI adds them
            setSuggestions(names.slice(0, 5));
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-6 rounded-2xl border border-indigo-100 mb-6">
            <div className="flex items-center gap-2 mb-4">
                <Sparkles className="text-purple-600" size={20} />
                <h3 className="font-bold text-gray-900">Geen inspiratie? Laat AI teamnamen bedenken!</h3>
            </div>

            <div className="flex gap-2 mb-4">
                <input
                    type="text"
                    placeholder="Typ een thema (bijv. 'Bier', 'Dieren', 'Superhelden')..."
                    className="flex-1 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 outline-none"
                    value={theme}
                    onChange={(e) => setTheme(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && generateNames()}
                />
                <Button onClick={generateNames} disabled={loading || !theme}>
                    {loading ? <RefreshCw className="animate-spin" /> : 'Genereer'}
                </Button>
            </div>

            {suggestions.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                    {suggestions.map((name, i) => (
                        <div key={i} className="bg-white p-2 rounded-lg border border-gray-200 shadow-sm flex justify-between items-center group hover:border-purple-300 transition-all">
                            <span className="font-medium text-gray-800 truncate">{name}</span>
                            <button
                                onClick={() => onAddTeam(name)}
                                className="p-1 bg-green-50 text-green-600 rounded hover:bg-green-100 transition-colors"
                                title="Gebruik deze naam"
                            >
                                <Plus size={16} />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
